import { TimeSlotAvailability, TimeSlotButton, TimeSlotValue } from './TimeSlot.styles'

interface TimeSlotProps {
  time: string
  availability: number
  active?: boolean
  onClick?: () => void
}

const TimeSlot = ({ time, availability, active, onClick }: TimeSlotProps) => {
  return (
    <TimeSlotButton type="button" active={active} onClick={onClick}>
      <TimeSlotValue>{time}</TimeSlotValue>
      <TimeSlotAvailability>({availability})</TimeSlotAvailability>
    </TimeSlotButton>
  )
}

export default TimeSlot
